import { useGetUserNameWithFallback } from '@pba/react-utils';
import type { ComponentProps, ReactNode } from 'react';
import { AvatarWrapper } from 'ui';
import { useUser } from 'features/auth';
// TODO: QuickViewCardUser is only borrowed as a convenient shape. This component does not use QuickViewUserCard — extract a shared user type instead of importing from quick-view-user-card.
import type { QuickViewCardUser } from '../quick-view-user-card';
import { UserLink } from '../user-link';
import { UserPopover } from '../user-popover';

type P = {
  extra?: ReactNode;
  popoverProps?: ComponentProps<typeof UserPopover>['popoverProps'];
  user: QuickViewCardUser;
};

const UserAvatarPopover = ({ extra, popoverProps, user }: P) => {
  const { railsUserData: viewer } = useUser();
  const getUserNameWithFallback = useGetUserNameWithFallback();

  return (
    <UserPopover popoverProps={popoverProps} user={user}>
      <UserLink userId={user.id}>
        <AvatarWrapper
          avatar={{ src: user.profilePhoto }}
          extra={extra}
          user={{ isViewer: user.id === viewer.id, name: getUserNameWithFallback(user) }}
        />
      </UserLink>
    </UserPopover>
  );
};

export default UserAvatarPopover;
